export default "__VITE_ASSET__BquGA4eA__"